<template>
  <CFormGroup wrapperClasses="input-group pt-2">
    <template #label>Vendor (supplier)</template>
    <template #input>
      <v-select
        class="w-100"
        :value="selectedVendor"
        :label="'name'"
        :options="vendorItems"
        placeholder="Search or select a vendor"
        @input="handleVendorSelect"
      >
        <template #no-options>
          No vendors match.
        </template>
        <template #list-footer>
          <li class="border-top">
            <button
              type="button"
              class="btn btn-link btn-block text-left"
              @click="$emit('add-new-vendor')"
            >
              <CIcon name="cil-plus" /> Add new vendor
            </button>
          </li>
        </template>
      </v-select>
    </template>
  </CFormGroup>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "VendorSelectComponent",
  components: {
    vSelect,
  },
  props: {
    selectedVendor: {
      type: Object,
      default: null,
    },
    vendorItems: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleVendorSelect(selected) {
      this.$emit("vendor-selected", selected);
    },
  },
};
</script>